import { Dropdown } from "@fluentui/react-northstar";
import React from "react";

import { Identity } from "./Identity";

type User = {
  id: string;
  name: string;
};

type Props = {
  users: User[];
  value: string | undefined;
  onSelected: (id?: string) => void;
};

export const UserDropdown: React.FC<Props> = ({ users, value, onSelected }) => {
  return (
    <Dropdown
      search
      clearable
      variables={{ backgroundColor: "var(--stardustui-colorScheme-default-backgroundFocus)" }}
      fluid
      placeholder="Search for users"
      items={users}
      value={value ? users.find(u => u.id === value) : undefined}
      renderSelectedItem={(Item, props) => {
        return <Item {...props} header={<Identity name={(props as User).name} />} />;
      }}
      renderItem={(Item, props) => (
        <Item
          {...props}
          key={(props as User).id}
          header={<Identity name={(props as User).name} />}
        />
      )}
      itemToString={item => {
        if (!item) {
          return "";
        }
        return (item as User).name;
      }}
      onChange={(_e, d) => {
        if (d) {
          const item = d.value as User;
          onSelected(item?.id);
        }
      }}
    />
  );
};
